module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "widget"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Workshops"), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Additional workshops and Live QAs featuring special guests'),
      expression: "'Additional workshops and Live QAs featuring special guests'"
    }],
    staticClass: "clippie fa fa-info-circle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "toggle-widget",
    on: {
      "click": function($event) {
        _vm.open = !_vm.open
      }
    }
  }, [(_vm.open === true) ? _c('i', {
    staticClass: "fa fa-minus"
  }) : _c('i', {
    staticClass: "fa fa-plus"
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.open),
      expression: "open"
    }],
    staticClass: "panel-body"
  }, [_c('VuePerfectScrollbar', {
    staticClass: "scroll-area"
  }, [((_vm.upcomingWorkshops && _vm.upcomingWorkshops.length > 0) || (_vm.pastWorkshops && _vm.pastWorkshops.length > 0)) ? _c('ul', {
    staticClass: "class-alerts clearfix"
  }, [_vm._l((_vm.upcomingWorkshops), function(workshop) {
    return _c('li', [_c('a', {
      attrs: {
        "href": workshop.url,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": require("./../../assets/img/bullhorn.png")
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "alert-text"
    }, [_c('span', {
      staticClass: "alert-name"
    }, [_vm._v(_vm._s(workshop.name))]), _vm._v(" "), _c('br'), _c('span', [_vm._v(_vm._s(_vm._f("shortDate")(workshop.date)))]), _c('br'), _vm._v(" "), _c('countdown', {
      attrs: {
        "date": workshop.date
      }
    })], 1)])])
  }), _vm._v(" "), _vm._l((_vm.pastWorkshops), function(workshop) {
    return _c('li', [_c('a', {
      attrs: {
        "href": workshop.archiveUrl,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": require("./../../assets/img/bullhorn.png")
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "alert-text"
    }, [_c('span', {
      staticClass: "alert-name"
    }, [_vm._v(_vm._s(workshop.name))]), _vm._v(" "), _c('br'), _c('span', {
      staticStyle: {
        "color": "#33ccff"
      }
    }, [_vm._v("Archive")])])])])
  })], 2) : _c('p', [_vm._v("No workshops scheduled")])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4032a29c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/Workshops.vue
// module id = 2033
// module chunks = 2